// This function updates the price and discount
function updatePriceAndDiscount(variant) {
  var selectedVariantPrice = variantPrices[variant];
  if (selectedVariantPrice) {
    var discount_value = selectedVariantPrice * 0.20;
    var sales_price = selectedVariantPrice - discount_value;

    document.querySelector('.savings').textContent = "£" + discount_value.toFixed(2);
    document.querySelector('.discounted-price').textContent = "Discounted Price: £" + sales_price.toFixed(2);
  }
}

// Get all radio buttons
var radios = document.querySelectorAll('.options-selection__option-value-input');

// Add event listeners to all radio buttons
radios.forEach(function(radio) {
  radio.addEventListener('change', function() {
    var selectedOptions = document.querySelectorAll('.options-selection__option-value-input:checked');
    var variant = Array.from(selectedOptions).map(option => option.value).join(' / ');
    updatePriceAndDiscount(variant);
  });
});

// Get the currently selected variant
var currentVariant = Array.from(document.querySelectorAll('.options-selection__option-value-input:checked')).map(option => option.value).join(' / ');

// Update the price and discount based on the currently selected variant
updatePriceAndDiscount(currentVariant);
